import { loanErrorLogger } from '../services/sentryService';
import BaseLasStrategy from './BaseLasStrategy';
import ScLoanError from './utils/scLoanError';

const lasRunner = async <T extends BaseLasStrategy>(lasStrategy: T) => {
  try {
    await lasStrategy.initInteraction();
    await lasStrategy.runInteraction();
  } catch (e) {
    if (!(e instanceof ScLoanError)) {
      loanErrorLogger.log(e);
    }
    return lasStrategy.handleInteractionError(e);
  }
  return lasStrategy.finishInteraction();
};

export default lasRunner;
